import { __GetContentTypeConfigNew } from '../../../../../../../../utils/getters/gettersV2';

/**
 * `attributeThematicTabs` (optional) — when supplied, SM_AnnoLightbox renders
 * the sub-themes section as multiple sections (one per tab), each scoping options
 * by meta.taxonomyRole client-side. Currently set when the tenant's aiAnnotation.mode is non-legacy
 * is on. Same selected values still flow through tagType="subThemes".
 */
export const buildHierarchicalTagTypesConfig = ({
  shouldUseSMLightbox = false,
  annotationTagsCount = null,
  attributeThematicTabs = null,
}) => {
  if (shouldUseSMLightbox && annotationTagsCount) {
    const config = [];

    if (annotationTagsCount.themes > 0) {
      config.push({
        tagType: 'themes',
        reactKey: 'themes-self-managed',
        icon: 'FolderSolid',
        title: __GetContentTypeConfigNew('themes')?.general?.content?.title || 'Themes'
      });
    }

    if (annotationTagsCount.subThemes > 0) {
      config.push({
        tagType: 'subThemes',
        reactKey: 'subthemes-self-managed',
        icon: 'FolderSolid',
        title: __GetContentTypeConfigNew('subThemes')?.general?.content?.title || 'Sub-Themes',
        ...(attributeThematicTabs ? { tabs: attributeThematicTabs } : {}),
      });
    }

    if (annotationTagsCount.tags > 0) {
      config.push({
        tagType: 'tags',
        reactKey: 'tags-self-managed',
        icon: 'TagsSolid',
        title: __GetContentTypeConfigNew('tags')?.general?.content?.title || 'Tags'
      });
    }

    return config;
  }

  return [];
};
